//options: https://glidejs.com/docs/options/
import Glide from '@glidejs/glide'
import breakpoints from '../breakpoints';

/**
 * Create a carousel for vehicle page image carousel
 */
export const init = () => {
  const carouselElement = document.querySelector('.vehicle-image-carousel .glide');

  const glide = new Glide(carouselElement, {
    type: 'carousel',
    focusAt: 'center',
    startAt: 0,
    perView: 1,
    peek: 850,
    gap: 24,
    keyboard: false, //keyboard arrows controlled carousel even if it was not selected
    breakpoints: {
      [breakpoints.xxxxl - 1]: {
        peek: 700
      },
      [breakpoints.xxxl - 1]: {
        peek: 550
      },
      [breakpoints.xxl - 1]: {
        peek: 400
      },
      [breakpoints.xl - 1]: {
        peek: 300
      },
      [breakpoints.lg - 1]: {
        peek: 100
      },
      [breakpoints.sm - 1]: {
        peek: 24,
        gap: 8
      },
      [breakpoints.xs - 1]: {
        peek: 13,
        gap: 4
      }
    }

  });

  /**
   * update current slide number
   */
  glide.on('move.after', function() {
    const text = document.querySelector('.js-vehicle-image-carousel__running-number');
    if(text && typeof glide.index === 'number') text.innerHTML = glide.index + 1;
  });

  //add data attribute to slides so we can activate that slide by clicking on it
  carouselElement.querySelectorAll('.glide__slide').forEach((slide, index) => {
    slide.dataset.sliderIndex = index
  });

  glide.mount();

  //activate that slide by clicking on it
  carouselElement.querySelectorAll('.glide__slide').forEach((slide) => {
    slide.addEventListener('click', () => {
      const sliderIndex = slide.dataset.sliderIndex;
      if (sliderIndex && sliderIndex >= 0) glide.go('='+sliderIndex);
    });
  });
}
